// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Big from "@wino/accounting/src/Big.res.js";
import * as BigJs from "big.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function sumManyCharges(charges) {
  return Stdlib_Array.reduce(charges, BigJs.Big(0), (acc, charge) => acc.plus(BigJs.Big(charge))).toNumber();
}

function toNetValue(value, discount) {
  let discount$1 = discount >= 0 ? discount : 0;
  let result = Big.Operators.$neg$dot(BigJs.Big(value), BigJs.Big(discount$1)).toNumber();
  if (result >= 0) {
    return result;
  } else {
    return 0;
  }
}

function fromNetValue(value, discount) {
  let discount$1 = discount >= 0 ? discount : 0;
  let result = Big.Operators.$plus$dot(BigJs.Big(value), BigJs.Big(discount$1)).toNumber();
  if (result >= 0) {
    return result;
  } else {
    return 0;
  }
}

function toValueWithCharges(value, charges) {
  let charges$1 = charges >= 0 ? charges : 0;
  return Big.Operators.$plus$dot(BigJs.Big(value), BigJs.Big(charges$1)).toNumber();
}

function fromValueWithCharges(value, charges) {
  let charges$1 = charges >= 0 ? charges : 0;
  return Big.Operators.$neg$dot(BigJs.Big(value), BigJs.Big(charges$1)).toNumber();
}

let Purchase = {
  toNetValue: toNetValue,
  fromNetValue: fromNetValue,
  toValueWithCharges: toValueWithCharges,
  fromValueWithCharges: fromValueWithCharges
};

function remove(value, charges) {
  let charges$1 = charges >= 0 ? charges : 0;
  return Big.Operators.$neg$dot(BigJs.Big(value), BigJs.Big(charges$1)).toNumber();
}

function addBack(value, charges) {
  let charges$1 = charges >= 0 ? charges : 0;
  return Big.Operators.$plus$dot(BigJs.Big(value), BigJs.Big(charges$1)).toNumber();
}

let Charges = {
  remove: remove,
  addBack: addBack
};

function add(value, taxRate) {
  let taxRate$1 = taxRate >= 0 ? taxRate : 0;
  return Big.Operators.$plus$dot(BigJs.Big(value), Big.Operators.$slash$dot(Big.Operators.$star$dot(BigJs.Big(value), BigJs.Big(taxRate$1)), BigJs.Big(100))).round(10).toNumber();
}

function removeBack(value, taxRate) {
  let taxRate$1 = taxRate >= 0 ? taxRate : 0;
  return Big.Operators.$slash$dot(Big.Operators.$star$dot(BigJs.Big(value), BigJs.Big(100)), Big.Operators.$plus$dot(BigJs.Big(100), BigJs.Big(taxRate$1))).round(10).toNumber();
}

let Tax = {
  add: add,
  removeBack: removeBack
};

function coefficient(taxes) {
  return Stdlib_Array.reduce(taxes, BigJs.Big(0), (acc, param) => {
    let ratio = param.ratio;
    let rate = param.rate;
    let taxRate = rate >= 0 ? rate : 0;
    let taxRatio = ratio >= 0 ? ratio : 0;
    return Big.Operators.$plus$dot(acc, Big.Operators.$star$dot(BigJs.Big(taxRatio), Big.Operators.$plus$dot(BigJs.Big(1), Big.Operators.$slash$dot(BigJs.Big(taxRate), BigJs.Big(100)))));
  });
}

function add$1(value, taxes) {
  let taxCoefficient = coefficient(taxes);
  if (taxCoefficient.toNumber() === 0) {
    return value;
  } else {
    return Big.Operators.$star$dot(BigJs.Big(value), taxCoefficient).round(10).toNumber();
  }
}

function removeBack$1(value, taxes) {
  let taxCoefficient = coefficient(taxes);
  if (taxCoefficient.toNumber() === 0) {
    return value;
  } else {
    return Big.Operators.$slash$dot(BigJs.Big(value), taxCoefficient).round(10).toNumber();
  }
}

function compute(value, purchasePrice) {
  let purchasePrice$1 = purchasePrice >= 0 ? purchasePrice : 0;
  return Big.Operators.$neg$dot(BigJs.Big(value), BigJs.Big(purchasePrice$1)).toNumber();
}

let Margin = {
  compute: compute
};

function apply(priceValue, kind, purchasePrice, charges, taxRate) {
  let priceExcludingChargesAndTax = remove(priceValue, charges);
  let rateValue;
  switch (kind) {
    case "Coefficient" :
      if (purchasePrice !== 0) {
        let priceIncludingChargesAndTax = add(priceExcludingChargesAndTax, taxRate);
        rateValue = Primitive_option.some(Big.Operators.$slash$dot(BigJs.Big(priceIncludingChargesAndTax), BigJs.Big(purchasePrice)));
      } else {
        rateValue = undefined;
      }
      break;
    case "MarginRate" :
      rateValue = priceExcludingChargesAndTax !== 0 ? Primitive_option.some(Big.Operators.$star$dot(Big.Operators.$slash$dot(Big.Operators.$neg$dot(BigJs.Big(priceExcludingChargesAndTax), BigJs.Big(purchasePrice)), BigJs.Big(priceExcludingChargesAndTax)), BigJs.Big(100))) : undefined;
      break;
    case "MarkupRate" :
      rateValue = purchasePrice !== 0 ? Primitive_option.some(Big.Operators.$star$dot(Big.Operators.$slash$dot(Big.Operators.$neg$dot(BigJs.Big(priceExcludingChargesAndTax), BigJs.Big(purchasePrice)), BigJs.Big(purchasePrice)), BigJs.Big(100))) : undefined;
      break;
  }
  return Stdlib_Option.map(rateValue, prim => prim.toNumber());
}

function undo(rateValue, kind, purchasePrice, charges, taxRate) {
  let priceValue;
  switch (kind) {
    case "Coefficient" :
      let priceIncludingChargesAndTax = Big.Operators.$star$dot(BigJs.Big(rateValue), BigJs.Big(purchasePrice)).toNumber();
      priceValue = removeBack(priceIncludingChargesAndTax, taxRate);
      break;
    case "MarginRate" :
      let operand = Big.Operators.$neg$dot(BigJs.Big(1), Big.Operators.$slash$dot(BigJs.Big(rateValue), BigJs.Big(100)));
      priceValue = operand.toNumber() !== 0 ? Big.Operators.$slash$dot(BigJs.Big(purchasePrice), operand).toNumber() : undefined;
      break;
    case "MarkupRate" :
      priceValue = Big.Operators.$star$dot(BigJs.Big(purchasePrice), Big.Operators.$plus$dot(BigJs.Big(1), Big.Operators.$slash$dot(BigJs.Big(rateValue), BigJs.Big(100)))).toNumber();
      break;
  }
  return Stdlib_Option.map(priceValue, value => addBack(value, charges));
}

let Rate = {
  apply: apply,
  undo: undo
};

let Retail_CompoundTax = {
  add: add$1,
  removeBack: removeBack$1
};

let Retail = {
  Charges: Charges,
  Tax: Tax,
  CompoundTax: Retail_CompoundTax,
  Margin: Margin,
  Rate: Rate
};

export {
  sumManyCharges,
  Purchase,
  Retail,
}
/* big.js Not a pure module */
